<script setup lang="ts">
import { computed } from "vue";
import { type MessageThreadChannelEnum } from "@/api/javaapi/models/message-thread.ts";

const airbnbLogo = new URL("@/assets/images/airbnb.png", import.meta.url).href;
const bdcLogo = new URL("@/assets/images/bdc.png", import.meta.url).href;
const vrboLogo = new URL("@/assets/images/vrbo.png", import.meta.url).href;

const props = defineProps<{
  name: string,
  preview: string,
  date: string,
  channel: MessageThreadChannelEnum,
  new: boolean
}>();

const integrationLogo = computed(() => {
  switch (props.channel) {
    case "AIRBNB":
      return airbnbLogo;
    case "BDC":
      return bdcLogo;
    case "VRBO":
      return vrboLogo;
    default:
      return false;
  }
});

const previewFormatted = computed(() => {
  const maxLength = 80;
  let preview = props.preview;
  if (preview.length > maxLength) {
    preview = preview.substring(0, maxLength) + "...";
  }
  return preview;
});
</script>

<template>
  <div
    class="flex items-center gap-3 w-full p-3 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer overflow-hidden"
    :class="{ 'font-bold': props.new }"
    @click="$emit('click')"
  >
    <div class="flex items-center justify-center w-[42px] h-[42px] flex-shrink-0">
      <img v-if="integrationLogo" :src="integrationLogo" class="w-8 h-8 object-contain rounded-full" />
      <i v-else class="pi pi-mobile text-gray-700 dark:text-gray-300 text-xl" />
    </div>
    <div class="flex flex-col flex-1 min-w-0">
      <div class="flex justify-between items-center gap-2">
        <div class="text-gray-900 dark:text-gray-100 truncate flex-1">
          {{ props.name }}
        </div>
        <div class="text-gray-500 dark:text-gray-400 text-xs whitespace-nowrap flex-shrink-0">
          {{ props.date }}
        </div>
      </div>
      <div class="text-gray-600 dark:text-gray-400 text-sm line-clamp-2 break-words">
        {{ previewFormatted }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.break-all {
  word-break: break-all;
}
</style>